import {
  AspectRatio,
  Typography,
  Button,
  Container,
  Grid,
  Stack,
  Input,
  FormLabel,
  FormControl,
  Alert,
  Box,
  Link,
  LinearProgress
} from '@mui/joy';
import { useState } from 'react';
import { signInWithEmailAndPassword, getAuth } from 'firebase/auth';
import { useUser } from '../context/user';

const LandingPage = () => {
  const { loading } = useUser();
  const [error, setError] = useState(false);
  const [processingAuth, setProcessingAuth] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async event => {
    event.preventDefault();
    setProcessingAuth(true);
    try {
      await signInWithEmailAndPassword(getAuth(), email, password);
    } catch (error) {
      console.error('error', error);
      setError(true);
    }
    setProcessingAuth(false);
  };

  if (loading) {
    return <LinearProgress />;
  }

  return (
    <Container>
      <Grid
        container
        alignItems="center"
        sx={{
          minHeight: '100vh'
        }}
      >
        <Grid xs={12} lg={6} display={{ xs: 'none', lg: 'block', padding: 11 }}>
          <AspectRatio
            variant="outlined"
            minHeight={555}
            sx={{ borderRadius: 'sm' }}
          >
            <img
              src="https://wirthhats.com/cdn/shop/files/check-in-tee-03.jpg?v=1712958198"
              alt="Wirth Foundation"
            />
          </AspectRatio>
        </Grid>
        <Grid xs={12} lg={6} p={3}>
          <Stack spacing={3}>
            <Typography level="h2">Wirth Foundation</Typography>
            <Typography
              sx={{
                fontSize: {
                  xs: '15px',
                  sm: '18px'
                }
              }}
            >
              Wirth is a social venture that champions radical self-worth
              through quality hats and mental health counselling.
            </Typography>
            {error && (
              <Alert severity="danger">
                Something went wrong... try again!
              </Alert>
            )}

            <Stack
              component="form"
              spacing={2}
              noValidate
              autoComplete="off"
              onSubmit={handleLogin}
            >
              <Typography level="body-lg">Welcome back admins.</Typography>
              <FormControl>
                <FormLabel>Email address</FormLabel>
                <Input
                  required
                  type="email"
                  autoComplete="email"
                  onChange={e => setEmail(e.target.value)}
                  value={email}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Password</FormLabel>
                <Input
                  required
                  type="password"
                  autoComplete="current-password"
                  onChange={e => setPassword(e.target.value)}
                  value={password}
                />
              </FormControl>

              <Button type="submit" size="lg" loading={processingAuth}>
                Login
              </Button>
            </Stack>
            <Box textAlign="right">
              <Typography level="body-sm">
                Any issues or questions, please email us.
              </Typography>
              <Link href="mailto:support@golightlyplus.com" level="body-sm">
                support@golightlyplus.com
              </Link>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
};

export default LandingPage;
